import doc                 from '@widesk-core/decorators/doc';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';
import model               from '@widesk-core/decorators/model';

@doc.path('/participation_statuses/{?id}')
@model.cacheDuration()
abstract class AbstractParticipationStatusModel extends WebsiteServiceModel {
	declare protected _tsFilters: {
		partial: string;
	};

	@doc.string declare name: string;
	@doc.number declare value: number;
	@doc.string declare label: string;
	@doc.string declare reference: Website_ParticipationStatusReference;
}

export default AbstractParticipationStatusModel;
